import { Controller } from "@hotwired/stimulus"
import { canHover } from '../../helpers/media_helpers'

export default class extends Controller {
  static targets = ['linkItem', 'button', 'menu']

  toggleOnTap() {
    if (canHover()) return

    this.toggle()
  }

  toggle() {
    this.#isOpen ? this.close() : this.open()
  }

  closeOnClickOutside({ target }) {
    if (!this.#isOpen) return

    for (const elem of [this.buttonTarget, this.menuTarget]) {
      if (elem.contains(target)) return
    }

    this.close()
  }

  open() {
    if (this.#isOpen) return

    this.menuTarget.innerHTML = ''
    this.#hiddenLinkItems.forEach(v => this.menuTarget.appendChild(v))

    this.buttonTarget.setAttribute('aria-expanded', 'true')
    this.menuTarget.setAttribute('aria-hidden', 'false')
  }

  close() {
    if (!this.#isOpen) return

    this.menuTarget.innerHTML = ''

    this.buttonTarget.setAttribute('aria-expanded', 'false')
    this.menuTarget.setAttribute('aria-hidden', 'true')
  }

  get #isOpen() {
    return this.menuTarget.getAttribute('aria-hidden') === 'false'
  }

  get #hiddenLinkItems() {
    return this.linkItemTargets.
      filter(v => getComputedStyle(v).getPropertyValue('display') === 'none').
      map(v => v.cloneNode(true))
  }
}
